// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { hederaTestnet as _hederaTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the hederaTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 296
 * Chain Name: Hedera Testnet
 * Default Block Explorer: https://hashscan.io/testnet
 * Default RPC URL: https://testnet.hashio.io/api
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { hederaTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: hederaTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const hederaTestnet = createCommon({
	..._hederaTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
